module.exports = __webpack_public_path__ + "media/images/iconRight-443a4a501cce2fed94d59a687a86720f.png";